export default {
  女装: "Veshje e grave",
  男装: "Burra",
  手机和小工具: "Telefon celular dhe mjete të vogla",
  居家生活: "Jeta në shtëpi",
  电脑及周边设备: "Pajisje kompjuterike dhe periferike",
  美容及个人护理: "Bukuria dhe Kujdesi Personal",
  家用电器: "Pajisje",
  健康与保健: "Kujdesi shëndetësor dhe shëndetësor",
  食品和饮料: "Ushqim dhe pije",
  玩具_儿童和婴儿: "Lodra, fëmijë dhe foshnje",
  童装时尚: "Moda e veshjeve për fëmijë",
  视频游戏: "lojë me video",
  运动与户外: "Ushtrime dhe në natyrë",
  爱好与书籍: "Hobi dhe libra",
  相机和无人机: "Kamera dhe drone",
  宠物食品及用品: "Ushqim për kafshë shtëpiake dhe furnizime",
  女士包袋: "Çantë për zonja",
  男士包袋: "Çantë për burra",
  珠宝及配饰: "Bizhuteri dhe aksesorë",
  手表: "vëzhgim",
  女鞋: "Këpucë për gratë",
  男装鞋: "Këpucë për burra",
  汽车: "makinë",
  我附近的ShopeePay: "Shopeepay im aty pranë",
  餐饮_旅行和服务: "Ushqim, Udhëtim dhe Shërbim",
  旅行及行李: "Udhëtimi dhe bagazhet",
  各种各样的: "I ndryshëm",
  我是来买什么的: "Unë jam këtu për të blerë",
  对不起_找不到_相关的商品:
    "Na vjen keq, ju nuk mund të gjeni produkte të lidhura [{0}]",
  类别: "kategori",
  产品: "produkt",
  店铺: "Dyqan",
  首页: "në faqen e parë",
  限时秒杀: "Spike me kohë të kufizuar",
  博客: "blog",
  所有品牌: "Të gjitha markat",
  所有类别: "Të gjitha kategoritë",
  我的购物车: "Karroca ime e blerjes",
  发货信息: "Informacione për shpërndarjen",
  交货信息: "Informacione për shpërndarjen",
  付款: "Pagesë",
  确认: "konfirmoj",
  您的购物车是空的: "Karroca juaj e blerjes është bosh",
  价格: "çmim",
  税: "Taksë",
  数量: "sasi",
  总计: "i plotë",
  移除: "Largoj",
  返回商店: "Kthehuni në dyqan",
  继续发货: "Vazhdoni dorëzimin",
  筛选: "filtër",
  价格范围: "Çmim",
  排序方式: "rendit",
  最新: "deri më tani",
  最旧: "I vjetër",
  价格从低到高: "Çmimi nga i ulët në të lartë",
  价格从高到低: "Çmimi nga i lartë në të ulët",
  选择交货类型: "Zgjidhni Llojin e Dorëzimit",
  送货上门: "Dorëzim",
  继续付款: "Vazhdoni të paguani",
  任何其他信息: "Çdo informacion tjetër",
  或者: "ose",
  您的钱包余额: "Bilanci juaj i portofolit",
  余额不足: "Ekuilibër i pamjaftueshëm",
  支付: "Paguaj",
  我同意: "Pajtohem",
  条款和条件: "Kushtet dhe kushtet",
  退货政策: "politika e kthimit",
  隐私政策: "Intimitet",
  概括: "Përmbledh",
  项目: "projekt",
  全部的: "Të gjitha -rreth",
  小计: "Skicë",
  总运费: "Ngarkesë totale",
  有优惠码吗_在这里输入: "A ka ndonjë kod zbritje? Hyni këtu",
  申请: "Zbatoj",
  编辑: "modifikoj",
  删除: "nxjerr",
  添加新地址: "Shtoni adresë të re",
  继续交货信息: "Vazhdoni informacionin e dorëzimit",
  选择一个地址: "Zgjidhni një adresë",
  购买历史: "Blej histori",
  下载: "shkarkim",
  已发送退款请求: "Kërkesa për rimbursim dërgon një kërkesë për rimbursim",
  对比: "kontrast",
  对话: "dialog",
  我的钱包: "Portofolin tim",
  工单: "Urdhër pune",
  管理个人资料: "Menaxhoni informacionin personal",
  登出: "Dal",
  重置对比列表: "Rivendosni listën e krahasimit",
  您的对比列表为空: "Lista juaj e krahasimit është bosh",
  在您的购物车中: "Në karrocën tuaj",
  在您的愿望清单中: "Në listën tuaj të dëshirave",
  在您的预定列表中: "Në listën tuaj të planifikuar",
  下载您的产品: "Shkarkoni produktin tuaj",
  选项: "Mundësi",
  什么都没找到: "Nuk gjeta asgjë",
  特色产品: "Produkt i veçantë",
  最畅销: "Shitje më e mirë",
  前_名: "Emri i mëparshëm {0}",
  查看更多: "Shikoni më shumë",
  查看所有类别: "Shikoni të gjitha kategoritë",
  十大品牌: "Dhjetë markat kryesore",
  查看所有品牌: "Shikoni të gjitha markat",
  登录: "Logoj",
  手机号码: "numër telefoni",
  密码: "fjalëkalim",
  密码长度为6到16个字符: "Gjatësia e fjalëkalimit është 6 deri në 16 karaktere",
  验证码: "Kod verifikimi",
  登录中: "Logoj",
  游客登录: "Hyrje në turistë",
  注册您的商店: "Regjistrohuni në dyqanin tuaj",
  现在申请: "Aplikoj tani",
  成为商家: "Tregohem",
  现在注册: "Regjistrohu tani",
  登录成功: "Hyrja e suksesshme",
  通知: "njoftoj",
  未找到通知: "Asnjë njoftim",
  评论: "Koment",
  估计运输时间: "Koha e vlerësuar e transportit",
  天: "qiell",
  所售: "Shitje",
  给商家留言: "Lini një mesazh për tregtarin",
  规格: "Specifikim",
  库存: "në magazinë",
  总价: "Çmim i përgjithshëm",
  添加到购物车: "Shto në karrocë",
  立即购买: "Blej tani",
  缺货: "i jashtëm",
  添加到愿望清单: "Shto në listën e dëshirave",
  加入对比列表: "Shtoni listën e krahasimit",
  退款: "Rimbursim",
  查看条款: "Shihni klauzolën",
  分享: "pjesë",
  描述: "përshkruaj",
  相关产品: "Produkte të lidhura",
  没有人问过商家: "Askush nuk e ka pyetur tregtarin",
  该产品暂无评论: "Nuk ka asnjë koment për këtë produkt",
  客户评论: "Koment i klientit",
  访问商店: "Vizitoni Dyqanin",
  畅销产品: "Produkte më të mira të shitjes",
  日期: "takim",
  订单编号: "Numër porosie",
  总额: "shumë",
  状态: "gjendje",
  愿望清单: "Listë e dëshirave",
  还没有添加任何东西: "Nuk kam shtuar asgjë akoma",
  注册: "regjistroj",
  邀请码: "Kod ftese",
  请输入邀请码: "Ju lutemi shkruani kodin e ftesës",
  用户名: "emër përdoruesi",
  请输入用户名: "Ju lutemi shkruani emrin e përdoruesit",
  用户名长度为6_14个字符:
    "Gjatësia e emrit të përdoruesit është 6-14 karaktere",
  昵称: "Emër nofe",
  请输入手机号码: "Ju lutemi shkruani numrin e telefonit celular",
  手机号码格式错误: "Gabim në formatin e numrit të telefonit celular",
  密码长度为6_16个字符: "Gjatësia e fjalëkalimit është 6-16 karaktere",
  确认密码: "Konfirmoni fjalëkalimin",
  请输入确认密码: "Ju lutemi shkruani fjalëkalimin e konfirmimit",
  提款密码: "Fjalëkalimi i tërheqjes",
  请输入提款密码: "Ju lutemi shkruani fjalëkalimin e tërheqjes",
  提款密码长度为4_16个字符:
    "Gjatësia e fjalëkalimit të tërheqjes është 4-16 karaktere",
  请输入验证码: "Ju lutemi shkruani kodin e verifikimit",
  在_s后发送: "Dërgoni pas {0} s",
  发送验证码: "Dërgoni kodin e verifikimit",
  注册即表示您同意我们的条款和条件:
    "Regjistrimi do të thotë që ju jeni dakord me kushtet dhe kushtet tona.",
  创建账号: "Krijoni një llogari",
  验证码发送成功: "Kodi i verifikimit dërgon me sukses",
  确认密码不一致: "Konfirmoni që fjalëkalimi është në kundërshtim",
  提款密码必须为数字: "Fjalëkalimi i tërheqjes duhet të numërohet",
  注册成功: "Regjistrohuni me sukses",
  购物车: "Karrocë pazar",
  账户: "Llogari",
  我的账户: "Llogaria ime",
  已经有一个账户: "Tashmë keni një llogari",
  新地址: "Adresë e re",
  编辑地址: "Adresa e redaktorit",
  保存: "ruaj",
  是否默认: "Nëse do të paracaktohet",
  具体地址: "Adresë specifike",
  请输入具体地址: "Ju lutemi shkruani adresën specifike",
  地区: "zonë",
  请输入地区: "Ju lutemi hyni në zonë",
  城市: "Qytet",
  请输入城市: "Ju lutemi hyni në qytet",
  省份: "provincë",
  请输入省份: "Ju lutemi hyni në krahinë",
  邮政编码: "kod postar",
  请输入邮政编码: "Ju lutemi shkruani kodin postar",
  电话号码: "numër telefoni",
  请输入电话号码: "Ju lutemi shkruani numrin e telefonit",
  收货人: "marrës",
  请输入收货人: "Ju lutemi shkruani marrësin",
  保存成功: "Jam i suksesshëm",
  最畅销的商家: "Tregtari më i mirë i shitjes",
  查看所有的商家: "Kontrolloni të gjithë tregtarët",
  支持政策: "Politikë mbështetëse",
  您的电子邮件地址: "Adresa juaj e emailit",
  订阅: "pajtim",
  联系方式: "Informacioni i Kontaktit",
  地址: "adresoj",
  美国伊利诺伊州霍夫曼庄园: "Holfman Manor, Illinois, USA",
  快速链接: "Lidhje e shpejtë",
  商家政策: "Politikë tregtare",
  submit: "paraqes",
  提款银行卡: "Kartë ADBB",
  我的面板: "Paneli im",
  提示: "aluzion",
  确定登出吗: "A jeni i sigurt që hyni?",
  确定: "I sigurt",
  取消: "Anuloj",
  项目添加到您的购物车: "Projekti i shtohet karrocës suaj",
  经常一起购买: "Blini shpesh",
  返回购物: "Kthimi i blerjeve",
  进行结算: "Vazhdoni të bëni arkë",
  帮助热线: "Ndihmoni linjën e nxehtë",
  查看所有通知: "Kontrolloni të gjitha njoftimet",
  请输入密码: "Ju lutemi shkruani fjalëkalimin",
  前往充值: "Shko për të rimbushur",
  购物车物品: "Karrocë pazar",
  查看购物车: "Kontrolloni shportën e blerjeve",
  钱包余额: "Ekuilibri i portofolit",
  充值钱包: "Thes për rimbushje",
  钱包充值_线下_: "Rimbushja e portofolit (offline)",
  申请提款: "Aplikoni për tërheqje",
  钱包收支明细: "Detajet e të ardhurave dhe shpenzimeve të portofolit",
  批准: "aprovoj",
  提现历史记录: "Rekrutimi i Rekordit Historik",
  类型: "lloj",
  信息: "informacion",
  付款方式: "Metodë pagese",
  请选择付款方式: "Ju lutemi zgjidhni metodën e pagesës",
  Bill_Type_RECHARGE_BACK: "Rimbushje",
  Bill_Type_RECHARGE_ONLINE: "Rimbushje në internet",
  Bill_Type_RECHARGE_REGISTER: "Regjistroj",
  Bill_Type_RECHARGE_JACKPOT: "Rimbushje",
  Bill_Type_RECHARGE_PRESENT: "Shpërblim për rimbushje",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Komision transferimi",
  Bill_Type_RECHARGE_TG_COMMISSION: "Komisioni i Promovimit të Rimbushjes",
  Bill_Type_REGISTER_TG_COMMISSION: "Komisioni i Regjistrit dhe Promovimit",
  Bill_Type_WITHDRAW: "Tërhiqem",
  Bill_Type_WITHDRAW_REJECT: "Tërhiqem",
  Bill_Type_DEDUCT_HANDLE: "Zbritje manuale",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Rimbushje",
  Bill_Type_MINING_PROFIT: "Të ardhura nga minierat",
  Bill_Type_MINING_PROFIT_COMMISSION:
    "Komisioni i Promovimit të të Ardhurave të Minierave",
  Bill_Type_VIP_UPGRADE: "Përditësoni VIP",
  Bill_Type_FINANCE_BUY: "Blerja e produktit të menaxhimit të pasurisë",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Kthimi i bilancit financiar",
  Bill_Type_FINANCE_FEE: "Tarifë e trajtimit financiar",
  Bill_Type_FINANCE_PROFIT: "Të ardhura financiare",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Blerja e Komisioneve për Produkte të Menaxhimit të Pasurisë",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "Komisioni i të Ardhurave të Produkteve të Menaxhimit të Pasurisë",
  Bill_Type_WHEEL_DRAW: "Pushkë e madhe",
  Bill_Type_BUY: "Blini mallra",
  Bill_Type_PAY_SHOP: "Paguaj tarifën e dorëzimit",
  Bill_Type_BUY_COMMISSION: "Blini Komisionin e Mallrave",
  Bill_Type_DEPOSIT: "Paguaj një depozitë",
  Bill_Type_STORE_BUY: "Blini mallra",
  Bill_Type_STORE_BUY_REFUND: "Blej një rimbursim",
  Bill_Type: "Lloji i ndryshimit të borxhit",
  Before_Money: "Shuma e mëparshme",
  Deal_Money: "Shuma e ndryshimit të llogarisë",
  After_Money: "Shuma pasuese",
  Bill_Time: "Koha e ndryshimit të llogarisë",
  No_More_Data: "Nuk ka më të dhëna",
  Apply_Money: "Shuma e aplikimit",
  Apply_Time: "Koha e aplikimit",
  Withdraw_Info: "Tarifa e Trajtimit: {Tarifa}, në llogarinë: {para}",
  提款订单状态_CHECKING: "Të rishikohet",
  提款订单状态_TRANSFERRING: "Transferoj",
  提款订单状态_PASS: "Konfirmoj",
  提款订单状态_REJECT: "I kundërt",
  暂无可用充值方式: "Nuk ka asnjë metodë të dobishme të rimbushjes",
  钱包收款码: "Kodi i mbledhjes së portofolit",
  钱包地址: "Adresa e kuletës",
  金额限制: "Kufiri i shumës",
  复制: "kopjoj",
  付款凭证: "Kupon pagese",
  收款银行: "Bankë",
  收款人: "Arkëtar",
  收款账号: "Llogarinë e faturës",
  付款银行: "Paguaj bankë",
  付款人: "Pagues",
  付款账号: "Llogari pagese",
  请输入付款银行: "Ju lutemi shkruani bankën e pagesave",
  请输入付款人: "Ju lutemi shkruani paguesin",
  请输入付款账号: "Ju lutemi shkruani llogarinë e pagesës",
  请上传付款凭证: "Ju lutemi ngarkoni kuponat e pagesës",
  充值金额: "Shuma e rimbushjes",
  请输入充值金额: "Ju lutemi shkruani shumën e rimbushjes",
  submitting: "Dorëzuar ...",
  Confirm: "paraqes",
  Commit_Success: "Dorëzimi i suksesshëm",
  balanceType_BALANCE: "Balancoj",
  balanceType_COMMISSION: "komision",
  Balance: "Bilanci i llogarisë",
  Wash_Money: "Kodim",
  请选择银行账户: "Ju lutemi zgjidhni llogarinë bankare",
  卡号类型: "Numër kartelash",
  提现金额: "Shuma e tërheqjes",
  提款金额: "Shuma e tërheqjes",
  不能为空: "Nuk mund të jetë bosh",
  金额不正确: "Shuma e pasaktë",
  please_input_withdraw_password: "Ju lutemi shkruani fjalëkalimin e tërheqjes",
  withdraw_password_format_error:
    "Fjalëkalimi i tërheqjes duhet të jetë karaktere 4-16-bit",
  Fee: "Tarifë trajtimi",
  实际到账: "Në të vërtetë",
  交易币种: "Monedhë tregtare",
  原始密码: "Fjalëkalim primitiv",
  confirm_password_error: "Fjalëkalimi në dy hyrje është i pasaktë",
  save_success: "Jam i suksesshëm",
  please_input: "Ju lutem hyni",
  old_password: "Fjalëkalimi i vjetër",
  new_password: "Fjalëkalim i ri",
  please_input_confirm_password: "Ju lutemi konfirmoni përsëri fjalëkalimin",
  没有找到符合条件的商品: "Nuk mund të gjej produkte të kualifikuar",
  Search: "kërkim",
  全部: "të gjithë",
  EnumGoodsOrderState_USER_PAY: "Të shpërndahet",
  EnumGoodsOrderState_SHOP_PAY: "Shpërndarje",
  EnumGoodsOrderState_SUCCESS: "Mbaroj",
  EnumGoodsOrderState_CANCEL: "Anuloj",
  EnumGoodsOrderState_REFUND_SUCCESS: "Rimbursim",
  订单号: "Numër porosie",
  用户名称: "Emrin e përdoruesit",
  收益: "të ardhura",
  支付时间: "Paguaj kohë",
  配送时间: "Koha e dorëzimit",
  完成时间: "Koha e plotë",
  发货: "Anije",
  全选: "Përzgjedhje e plotë",
  物品已添加到愿望清单: "Artikujt janë shtuar në listën e dëshirave",
  物品已添加到比较列表: "Artikujt janë shtuar në listën e krahasimit",
  购买成功提示: "Urime, Bleni me sukses",
  订单列表: "Listë",
  商品名: "Emrin e produktit",
  图片: "pikturë",
  没有品牌: "Pa markë",
  基本信息: "Informacioni Themelor",
  Account_Name: "Emër",
  Bank_Account: "Llogari bankare",
  Bank_Phone: "Rezervoni numrin e telefonit celular",
  IFSC: "Llogari IFSC",
  UPI: "Llogari UPI",
  PIX: "Numri i llogarisë PIX",
  CPF: "Llogari CPF",
  GCASH: "Llogari gcash",
  POWWI: "Llogari e Powwi",
  身份证号: "Numri i ID -së",
  Edit: "Rishikoj",
  Delete: "nxjerr",
  Add: "Rritje",
  Forget_Withdraw_Password: "Harrojeni me fjalëkalimin e tërheqjes",
  Bank_Card_Info: "Informacione për kartën e bankës",
  收款人地址: "Adresa e arkëtarëve",
  SWIFT: "I shpejtë",
  Bank_Branch: "Nëndeti",
  分行代码: "Kodin e degës",
  银行地址: "Adresë bankare",
  Email: "Postë elektronike",
  银行卡长度必须超过:
    "Gjatësia e kartës së bankës duhet të tejkalojë {gjatësinë}",
  银行卡格式不正确: "Formati i kartës bankare është i pasaktë",
  Do_you_confirm_delete: "A e konfirmoni fshirjen?",
  Please_Login_First: "Ju lutemi hyni së pari",
  Bank_Name: "Emër bankar",
  Please_add_bank_first:
    "Ju nuk keni lidhur një kartë bankare, ju lutemi shtojeni së pari",
  withdrawType: "Tërheqje",
  withdraw_money_limit:
    "Shuma e tërheqjes duhet të jetë më e madhe se 0 dhe më pak se ose e barabartë me {bilancin}",
  withdraw_times_limit:
    "Ju keni nxjerrë {sot me TREGTI} herë sot. A është e vendosur të tërheqë para?",
  Copy_Success: "Përsëritje",
  商店首页: "Faqe Home",
  所有产品: "Të gjitha produktet",
  新到货产品: "Produkt i ri -arrival",
  所有商家: "Të gjithë tregtarët",
  请上传: "Ju lutemi ngarkoni",
  请输入: "Ju lutem hyni",
  忘记密码: "Harrojeni fjalëkalimin",
  记得我: "Më kujto",
  共_件: "Pjesë totale {0}",
  取消订单: "Anulo porosinë",
  申请退款: "Aplikoni për rimbursim",
  未知商家: "Tregtar i panjohur",
  到账: "Llogari",
  提款订单状态: "Një status i urdhrit të tërheqjes",
  前_名类别: "Kategoria e parë {0}",
  取消订单原因_不想要了: "Nuk dua më",
  取消订单原因_商品错选_多选: "Gabimet e produktit/zgjedhja e shumëfishtë",
  取消订单原因_商品无货: "Jashtë -of -zell",
  取消订单原因_地址信息填写错误: "Plotësoni gabimin e informacionit të adresës",
  取消订单原因_商品降价: "Ulja e çmimit të mallit",
  取消订单原因_价格高于其他平台: "Çmimi është më i lartë se platformat e tjera",
  取消订单原因_没用_少用_错用优惠: "Asgjë/Përdorni më pak/zbritje gabimi",
  退款原因_拍错_多拍_不喜欢: "Merrni gabim/xhironi më shumë/nuk më pëlqen",
  退款原因_商品成分描述不符:
    "Përshkrimi i komponentit të produktit nuk përputhet",
  退款原因_与商家协商一致退款: "Konsultim me një rimbursim tregtar",
  退款原因_生产日期_保质期与商品描述不符:
    "Data e prodhimit/jeta e raftit nuk përputhet me përshkrimin e produktit",
  退款原因_图片_产地_批号_规格等描述不符:
    "Imazhi/Vendi i Origjinës/Numri i Serisë/Specifikimet, etj.",
  退款原因_质量问题: "Çështje cilësore",
  退款原因_商品变质_发霉_有异物: "Plaçkë e produktit/myk/trup i huaj",
  退款原因_少件_含缺少配件_:
    "Artikuj të vegjël (përfshirë mungesën e aksesorëve)",
  退款原因_收到商品时有破损_污渍_变形:
    "Kur merrni produktin, ka dëme/njollë/deformim",
  退款原因_假冒品牌: "I falsifikuar",
  退款原因_发票问题: "Problemi i faturës",
  退款原因_商家发错货: "Tregtarët dërgojnë mallra të gabuara",
  退款原因_预约不到_商家不给退换:
    "Nuk mund të bëj një takim/tregtar nuk do të kthehet",
  退款失败: "Dështim i rimbursimit",
  退款处理中: "Përpunim i rimbursimit",
  默认: "mospagim",
  产品查询: "Pyetje e produktit",
  商店LOGO: "Logo e dyqaneve",
  推广码: "Kod promovimi",
  查看所有: "Kontrolloj të gjitha",
  确认收货成功: "Konfirmoni që fatura është e suksesshme",
  物流公司: "Kompani logjistike",
  物流单号: "Numri i porosisë së logjistikës",
  发货时间: "Koha e dorëzimit",
  请先选择商品规格: "Ju lutemi zgjidhni së pari specifikimin e produktit",
  个人信息: "informacion personal",
  您的用户名: "Emri juaj i përdoruesit",
  你的名字: "Emri juaj",
  登录名: "emër përdoruesi",
  你的邮件: "Posta juaj",
  你的密码: "Fjalëkalimi juaj",
  重复输入密码: "Përsëriteni fjalëkalimin",
  店铺名称: "Emërt",
  证书类型: "Lloj",
  身份证: "Karta e identitetit",
  护照: "pasaportë",
  驾驶执照: "patentë shoferi",
  社会保障卡: "Kartë e sigurimeve shoqërore",
  证书正面: "Çertifikatë pozitive",
  证书反面: "Provë",
  确认收货: "Konfirmoni marrjen e mallrave",
  请选择取消订单的原因必选:
    "Ju lutemi zgjidhni arsyen e anulimit të porosisë (kërkohet):",
  请选择申请退款的原因必选:
    "Ju lutemi zgjidhni arsyen e aplikimit për një rimbursim (kërkohet):",
  留言: "mesazh",
  请输入留言: "Ju lutemi shkruani një mesazh",
  没有帐户: "Pa llogari",
  钱包充值: "Rimbushje",
  输入您的文字: "Futni tekstin tuaj",
  商家登录: "Hyni në treg",
  有关此产品的任何查询: "Çdo pyetje për këtë produkt",
  产品名称: "Emrin e produktit",
  你的问题: "Problemi juaj",
  白银店铺: "Dyqan argjendi",
  铂金店铺: "Dyqan platini",
  钻石店铺: "Dyqan diamanti",
  照片: "foto",
  已退货: "I kthyer",
  邮寄状态: "Statusi i postës",
  订单摘要: "Abstrakt",
  收件地址: "Adresa e të ardhurave",
  订购日期: "Datën e porosisë",
  订单状态: "Statusi i porosisë",
  总订单金额: "Shuma totale e porosisë",
  邮寄方式: "Metodë postare",
  附加信息: "Informacion shtesë",
  订单详细信息: "Informacion i detajuar",
  交货类型: "Lloji i dorëzimit",
  进行评论: "Koment",
  已评论: "I komentuar",
  订单金额: "Shuma e porosisë",
  优惠券: "Kupon",
  统一运费: "Transport i Unifikuar",
  送货地址: "Adresa e transportit",
  评分: "notë",
  你的意见: "Mendimi juaj",
  匿名: "anonim",
  现金: "arkëtoj",
  详情: "Detyrë",
  收货地址: "Adresa e faturës",
  暂时没有对话: "Asnjë dialog për momentin",
  你: "ju",
  输入您的回复: "Vendosni përgjigjen tuaj",
  删除成功: "Nxjerr",
  品牌: "markë",
  已缴纳的保证金: "Diferencë e paguar",
  黄金店铺: "Dyqan i artë",
  没有更多数据: "Nuk ka më të dhëna",
  站内信: "Letër -site",
  系统通知: "Njoftim i sistemit",
  邮箱: "Postë",
  手机号: "Numër telefoni",
  你的手机号: "Numri juaj i telefonit celular",
  营业执照: "Licencë biznesi",
  你的邮箱: "Kutia juaj postare",
  搜索结果: "Rezultatet e kërkimit",
  系统公告: "Njoftim i sistemit",
  客服: "shërbim ndaj klientit",
  消息已撤回: "Lajmet janë tërhequr",
  物流详情: "Detajet e logjistikës",
  充值: "kap",
  提现: "Tërhiqem",
  信用分: "Vlerësim",
  余额: "Balancoj",
  佣金: "komision",
  继续购物: "Vazhdoni blerjet",
  订单结算: "Shlyerje me porosi",
  加入对比: "Shtoni krahasimin",
  佣金余额: "Bilanc i komisionit",
  刷新: "rifreskoj",
  刷新成功: "Rifreskoj",
  官网: "Uebfaqe Zyrtare",
  税号: "Numër taksash",
  订单: "Urdhër",
  合计: "i plotë",
  系统安全: "Siguria e sistemit",
  Recharge_Money_Limit:
    "Shuma e rimbushjes duhet të jetë midis {min} dhe {max}",
  限时优惠: "Koha e kufizuar",
  高价回收: "Riciklim me çmim të lartë",
  姓名: "Emër",
  商品订单号: "Numri i porosisë së mallit",
  商品在线回收: "Riciklimi online i mallrave",
  提交: "paraqes",
  回收记录: "Rekord i rikuperimit",
  回收状态: "Statusi i rikuperimit",
  回收价格: "Çmimi i riciklimit",
  纳税码: "Kodin e taksave",
  买家登录: "Logoj",
  买家注册: "regjistroj",
  language: "Kinez",
  助力提示:
    "Ndihma për tregtarët mund të rrisë ekspozimin e platformës në dyqanet e tyre, dhe sa më i lartë të jetë numri kumulativ i ditëve, aq më i lartë është ekspozimi.",
  已累计助力: "Ndihmohet kumulativisht",
  今日已助力: "Sot ka ndihmuar",
  立即助力: "Ndihmoni menjëherë",
  商家助力: "Ndihma për tregtar",
  证件号码: "Numri i ID -së",
  证书号码: "Numri i certifikatës"
};
